import { render } from "./EvaluationHistory.vue?vue&type=template&id=09fb37d8"
import script from "./EvaluationHistory.vue?vue&type=script&lang=js"
export * from "./EvaluationHistory.vue?vue&type=script&lang=js"

import "./EvaluationHistory.vue?vue&type=style&index=0&id=09fb37d8&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__